/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.0 orion_us_plusSkin.glb -T 
Files: orion_us_plusSkin.glb [25.3MB] > C:\Users\eduardo.vieira\frontendOrion\public\models\orion_us_plusSkin-transformed.glb [879.17KB] (97%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function UsPlusSkin(pos) {
  const { nodes, materials } = useGLTF('/models/orion_us_plusSkin-transformed.glb')
  return (
    <group position={pos} dispose={null} rotation={[Math.PI/2,0,0]}>
      <mesh geometry={nodes.ImageToStlcom_orion_us_plus.geometry} material={materials['Material.003']} />
    </group>
  )
}

useGLTF.preload('/models/orion_us_plusSkin-transformed.glb')
